<div class="wraper-main-section mb-3">
    <div class="global-card-section global-card-side-section">
        <div class="global-header-section">
            <div class="svg-icon-panel" *ngIf="isQuickSearch">Quick Search</div>
            <div class="svg-icon-panel" *ngIf="isAdvancedSearch">Advanced Search</div>
            <div class="svg-icon-panel" *ngIf="isPowerSearch">Power Search</div>
        </div>
        <form *ngIf="searchQueriesForm" [formGroup]="searchQueriesForm" (ngSubmit)="runPowerSearch()">
            <div class="global-body-section" style="position:relative">
                <div class="power-spinner" *ngIf="showSpinner">
                    <i class="fa fa-spin fa-spinner"></i>
                </div>
                <div class="global-padding10">
                    <div class="text-right">
                        <button type="button" class="btn btn-primary" *ngIf="!isQuickSearch" (click)="onShowQuickSearch()">Quick Search</button>
                        <button type="button" class="btn btn-primary" *ngIf="!isAdvancedSearch" (click)="onShowAdvanceSearch()">Advanced Search</button>
                    </div>
                    <div class="quick-list" *ngIf="ddcustomsearch?.length>0">
                        <div class="quick-label"><span>Saved</span></div>
                        <div class="quick-input">
                            <select class="form-control" (change)="onSearchChange($event)" formControlName="ddcustomsearch">
                                <option value="">-Select One-</option>
                                <option *ngFor="let item of ddcustomsearch" [value]="item?.customSearchID">{{item?.displayName}}</option>
                            </select>
                        </div>
                    </div>

                    <hr style="border-color:#eee" />
                    <div class="quick-list">
                        <span *ngIf="islblMessage">Please select a search field.</span>
                        <span *ngIf="islblField">Please enter a search value.</span>
                    </div>
                    <div class="quick-list" *ngIf="searchClauseList.length>0">
                        <div class="quick-label"><span>Type </span></div>
                        <div class="quick-input">
                            <select class="form-control" formControlName="ddAndOr" (change)="onddAndOrChange()">
                                <option value="AND">And Search</option>
                                <option value="OR">Or Search</option>
                            </select>
                        </div>
                    </div>
                    <div class="quick-list" *ngIf="trField">
                        <div class="quick-label"><span>Search field</span></div>
                        <div class="quick-input">
                            <span *ngIf="islblField">{{lblField}}</span>
                            <select class="form-control" *ngIf="!islblField" formControlName="ddField" (change)="onFieldChange($event)">
                                <option *ngFor="let item of ddField" [value]="item?.value">{{item?.text}}</option>
                            </select>
                        </div>
                    </div>
                    <div class="quick-list" *ngIf="trOperator">
                        <div class="quick-label"><span></span></div>
                        <div class="quick-input">
                            <span *ngIf="islblOperator">{{lblOperator}}</span>
                            <select class="form-control" *ngIf="isddOpSearchText" formControlName="ddOpSearchText">
                                <option value="=">equals</option>
                                <option value="<>">not equals</option>
                                <option value="contains">contains</option>
                                <option value="does not contain">does not contain</option>
                                <option value="starts">starts with</option>
                                <option value="ends">ends with</option>
                                <option value=">=">equal or greater than</option>
                                <option value="<=">equal or less than</option>
                            </select>
                            <select class="form-control" *ngIf="isddOpClass" formControlName="ddOpClass">
                                <option value="=">equals</option>
                                <option value="<>">not equals</option>
                            </select>
                        </div>
                    </div>
                    <div class="quick-list" *ngIf="isEditText">
                        <div class="quick-label"><span> value</span></div>
                        <div class="quick-input">
                            <span *ngIf="islblTextValue">{{lblDDValue}}</span>
                            <input type="text" *ngIf="!islblTextValue" class="form-control" formControlName="txtSearch" />
                        </div>
                    </div>
                    <div class="quick-list" *ngIf="isddValue">
                        <div class="quick-label">
                            <span *ngIf="islblDDValue">{{lblDDValue}}</span>
                        </div>
                        <div class="quick-input">
                            <select multiple [size]="5" class="form-control" *ngIf="!islblDDValue" formControlName="ddValue">
                                <option *ngFor="let item of ddValueList" [value]="item?.id">{{item?.text}}</option>
                            </select>
                        </div>
                    </div>
                    <div class="quick-list" *ngIf="isEditCB">
                        <div class="quick-label">
                            <span>Value</span>
                        </div>
                        <div class="quick-input">
                            <span *ngIf="islblCBValue">{{lblCBValue}}</span>
                            <input type="checkbox" id="cbValue" *ngIf="!islblCBValue" class="checkbox" formControlName="cbValue" />
                        </div>
                    </div>
                    <div class="quick-list" *ngIf="trEditDate">
                        <div class="quick-label"></div>
                        <div class="quick-input">
                            <span>From</span>
                            <div class="custom-mat-cal">
                                <mat-form-field appearance="fill">
                                    <!--<mat-label>Choose a date</mat-label>-->
                                    <input matInput [matDatepicker]="picker" formControlName="fromDate">
                                    <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                                    <mat-datepicker #picker></mat-datepicker>
                                </mat-form-field>
                            </div>
                        </div>
                    </div>
                    <div class="quick-list" *ngIf="trEditDate">
                        <div class="quick-label"></div>
                        <div class="quick-input">
                            <span>To</span>
                            <div class="custom-mat-cal">
                                <mat-form-field appearance="fill">
                                    <!--<mat-label>Choose a date</mat-label>-->
                                    <input matInput [matDatepicker]="picker" formControlName="toDate">
                                    <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                                    <mat-datepicker #picker></mat-datepicker>
                                </mat-form-field>
                            </div>
                        </div>
                    </div>
                    <div class="quick-list" *ngIf="trBuzzScore">
                        <div class="quick-label"><span>Buzz score</span></div>
                        <div class="quick-input">
                            <div class="display-row">
                                <div>
                                    <span>From</span>
                                    <input formControlName="txtBuzzStart" (keypress)="_localService.onKeyDown($event)" />
                                </div>
                                <div class="margin-left10">
                                    <span>To</span>
                                    <input formControlName="txtBuzzEnd" (keypress)="_localService.onKeyDown($event)" />
                                </div>
                            </div>
                        </div>
                    </div>
                    <!--Metric Section Start-->
                    <div class="quick-list" *ngIf="trMetricDetails">
                        <div class="quick-label"><span>{{lblMetricName}}</span></div>
                        <div class="quick-input">
                            <select class="form-control" formControlName="ddMetricNames" (change)="onMetricNamesChange($event.target.value)">
                                <option value="">-None-</option>
                                <option *ngFor="let item of metricList" [value]="item">{{item}}</option>
                            </select>
                            <div class="mt-3" *ngIf="isShowMetricValues">
                                <select class="form-control" formControlName="ddMetricValues" (change)="onMetricValuesChange($event.target.value)">
                                    <option value="any">contains any</option>
                                    <option value="all">contains all</option>
                                    <option value="not">does not contain</option>
                                    <option value="any text">contains text</option>
                                </select>
                            </div>
                            <div class="mt-3" *ngIf="isShowMetricValues && !isMetricTextSearch">
                                <select class="form-control" formControlName="lbMetricsSelected" multiple="multiple" size="10">
                                    <option *ngFor="let item of listMetricValue" [value]="item">{{item}}</option>
                                </select>
                            </div>
                            <div class="mt-3" *ngIf="isMetricTextSearch && isShowMetricValues">
                                <input class="form-control" formControlName="txtMetricTextSearch" />
                            </div>
                        </div>
                    </div>
                    <!--Metric Section End-->
                    <div class="quick-list" *ngIf="trTags">
                        <div class="quick-label">Tags</div>
                        <div class="quick-input">
                            <select class="form-control" formControlName="ddOpTags">
                                <option value="any">contains any</option>
                                <option value="all">contains all</option>
                                <option value="not">does not contain</option>
                            </select>
                            <select id="vender" multiple="multiple" size="10" formControlName="lbTags">
                                <option *ngFor="let item of tagsObj" [value]="item?.id">{{item?.text}}</option>
                            </select>
                        </div>
                    </div>
                    <div class="quick-list" *ngIf="trEngagement">
                        <div class="quick-label">Engagement</div>
                        <div class="quick-input">
                            <select class="form-control" formControlName="ddEngagementType">
                                <option value="">-Select One-</option>
                                <option value="Email Opened">Email Opened</option>
                                <option value="Inbound Text">Inbound Text</option>
                                <option value="Inbound Call">Inbound Call</option>
                                <option value="Outbound Call">Outbound Call</option>
                                <option value="Voice Call">Call</option>
                                <option value="Slidecast Opened">Slidecast Opened</option>
                                <option value="Slidecast">Slidecast</option>
                                <option value="Contract Sent">Contract Sent</option>
                                <option value="Contract Opened">Contract Opened</option>
                                <option value="Contract Active">Contract Active</option>
                            </select>
                            <select class="form-control" formControlName="ddEngagementOperator">
                                <option value=">=">is greater than or equal to</option>
                                <option value="<=">is less than or equal to</option>
                                <option value="=">is equal to</option>
                            </select>
                            <select class="form-control" formControlName="ddEngagementValue">
                                <option value="TRUE">IS TRUE</option>
                                <option value="FALSE">IS FALSE</option>
                            </select>
                        </div>
                    </div>
                    <div class="quick-list">
                        <div class="quick-label">
                            <button type="button" matTooltip="Add" class="icon-btn" (click)="onAddToSearch()" *ngIf="isAddToSearch">
                                <i class="fa fa-plus" aria-hidden="true"></i>
                            </button>
                        </div>
                        <div class="quick-input text-right">
                            <button type="button" *ngIf="isStartOver" class="btn btn-primary" (click)="onStartOver()">Start Over</button>
                        </div>
                    </div>
                    <div class="quick-list" *ngIf="searchStatement" style="border-top: thin groove; font-size: 8pt;" nowrap colspan="3">
                        <div>
                            <span style="font-size:8pt;">Search Statement &nbsp; &nbsp;</span>
                            <span style="color: #009700" [innerHTML]="customsearch.displayClause?customsearch.displayClause:customsearch.whereClause"> </span>
                        </div>
                    </div>
                    <div>
                        <div class="common-list" *ngFor="let item of searchClauseList; let i = index">
                            <button type="button" matTooltip="Remove" class="icon-btn" (click)="onRemoveSearch(i)">
                                <i class="fa fa-minus" aria-hidden="true"></i>
                            </button>
                            <div class="table-cell">
                                <div style="color: green; font-size: 9pt; padding-left: 10px;" class="table-cell" [innerHTML]="item.clauseText"></div>
                            </div>
                        </div>
                        <div *ngIf="havingScoreDisplay">
                            <span style="color: green; font-size: 9pt; padding-left: 10px;" [innerHTML]="havingScoreDisplay"></span>
                        </div>
                        <div *ngIf="sbClauseUser">
                            <span style="color: green; font-size: 9pt; padding-left: 10px;" [innerHTML]="sbClauseUser"></span>
                        </div>
                    </div>
                    <!--search statement-->
                    <div class="quick-list" *ngIf="isUserDD">
                        <div class="quick-label">
                            <span>User</span>
                            <button type="button" matTooltip="Refresh" class="icon-btn" (click)="onRefresh()">
                                <i class="fa fa-refresh" aria-hidden="true"></i>
                            </button>
                            <select class="form-control mt-2" formControlName="ddOpUser">
                                <option value="=">=</option>
                                <option value="<>">&lt;&gt;</option>
                            </select>
                        </div>
                        <div class="quick-input">
                            <select multiple [size]="5" class="form-control" formControlName="ddUser">
                                <option value="0">-All-</option>
                                <option *ngFor="let item of usersObj" [value]="item?.value.toString()">{{item?.text}}</option>
                            </select>
                        </div>
                    </div>
                    <div class="quick-list" *ngIf="isTeamDD">
                        <div class="quick-label">
                            <span>Team</span>
                            <button type="button" matTooltip="Refresh" class="icon-btn" (click)="onRefresh()">
                                <i class="fa fa-refresh" aria-hidden="true"></i>
                            </button>
                            <select class="form-control mt-2" formControlName="ddOpTeam">
                                <option value="=">=</option>
                                <option value="<>">&lt;&gt;</option>
                            </select>
                        </div>
                        <div class="quick-input">
                            <select multiple [size]="5" class="form-control" formControlName="ddTeam">
                                <option value="0">-All-</option>
                                <option *ngFor="let item of teamObj" [value]="item?.id">{{item?.text}}</option>
                            </select>
                        </div>
                    </div>
                    <div class="quick-list" *ngIf="isOfficeDD">
                        <div class="quick-label">
                            <span>Office</span>
                            <button type="button" matTooltip="Refresh" class="icon-btn" (click)="onRefresh()">
                                <i class="fa fa-refresh" aria-hidden="true"></i>
                            </button>
                            <select class="form-control mt-2" formControlName="ddOpOffice">
                                <option value="=">=</option>
                                <option value="<>">&lt;&gt;</option>
                            </select>
                        </div>
                        <div class="quick-input">
                            <select multiple [size]="5" class="form-control" formControlName="ddOffice">
                                <option value="0">-All-</option>
                                <option *ngFor="let item of officeObj" [value]="item?.id">{{item?.text}}</option>
                            </select>
                        </div>
                    </div>
                    <div class="quick-list" *ngIf="searchContactCount" style="font-size: 8pt;" nowrap colspan="3">
                        <div>
                            <p style="font-size:8pt;">{{searchContactCount != "" ? searchContactCount : ""}}</p>
                        </div>
                    </div>


                    <div class="quick-list" *ngIf="isShowPnlSaved" style="align-items:flex-end">
                        <div class="quick-input" *ngIf="isShowDisplayText">
                            <span *ngIf="displayName =='' && isShowDisplayText" class="error-red">Please enter a descriptive name.</span>
                            <input type="text" [(ngModel)]="displayName" [ngModelOptions]="{standalone: true}" />
                        </div>
                        <div class="quick-label">
                            <button type="button" (click)="saveCustomSearch()" class="btn btn-primary">Save</button>
                        </div>
                    </div>
                    <div class="quick-list" style="justify-content: flex-end;" *ngIf="customsearch.customSearchID">
                        <div>
                            <button type="button" class="btn btn-danger" (click)="deleteSearch()">Delete</button>
                        </div>
                    </div>
                    <div class="quick-list">
                        <div><button type="submit" class="btn btn-primary ml-0">Get Results</button></div>
                    </div>
                </div>
            </div>
        </form>
    </div>
</div>
